import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeCrossed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m18.525 18.191c-1.9511.94668-4.2149 1.448-6.5254 1.445-5.9809 0-10.957-3.2923-11.999-7.6369.47661-1.976 1.7754-3.7812 3.7026-5.1464l-3.4674-2.6534 1.5684-1.1998 21.961 16.799-1.5684 1.2007zm-13.252-10.138c-1.5078 1.0483-2.5583 2.4257-3.0093 3.9457.3464 1.1595 1.0418 2.2411 2.031 3.1587.98912.91764 2.2446 1.646 3.6666 2.1271 1.4219.48096 2.971.70152 4.524.6438 1.5529-.0576 3.0668-.3918 4.4212-.97584l-2.2494-1.7209c-.9576.46152-2.0918.66036-3.2165.56388-1.1247-.09648-2.1732-.4824-2.9734-1.0946-.80026-.61219-1.3048-1.4143-1.4309-2.2746-.12607-.86038.1338-1.728.737-2.4606zm7.7401 5.9211-3.5961-2.7501c-.19738.38434-.24382.80437-.13366 1.2086.11016.40424.37216.77509.75383 1.0671.38168.29197.86646.4924 1.3949.57667.52842.08428 1.0786.04874 1.581-.10224zm8.755 1.9219-1.5872-1.2142c.74184-.80833 1.2701-1.7198 1.5551-2.6831-.30144-1.0101-.8682-1.9627-1.666-2.8s-1.8097-1.5417-2.9744-2.0705c-1.1647-.52876-2.4577-.87079-3.8006-1.0053-1.3429-.13452-2.7075-.058716-4.0109.22282l-1.7503-1.339c1.3832-.41579 2.8906-.64489 4.4657-.64489 5.9809 0 10.957 3.2923 12.001 7.6368-.33972 1.4137-1.1036 2.7478-2.2318 3.8973zm-10.076-7.7081c.70597-.033384 1.4133.04842 2.0748.23998s1.2624.4885 1.7626.87114c.50016.38263.88836.84223 1.1388 1.3483.25032.50609.35724 1.0471.31368 1.5872l-5.291-4.0475z",
		fill: "currentColor",
		strokeWidth: 1.2
	})]
});
const ForwardRef = forwardRef(SvgEyeCrossed);
export { ForwardRef as ReactComponent };
